import { SPB_AND_LO_IDS } from '../../constants/region';

export function isSpbOrLO(regionId: number) {
  return SPB_AND_LO_IDS.includes(regionId);
}
